import React from 'react';
import { useListForm } from '../../hooks/useListForm';
import { useSceneUpdate } from '../../hooks/useSceneUpdate';
import './OpenWorldSceneBackgrounds.css';
import CustomSelect from '../CustomSelect';

const INITIAL_DATA = {
  background_id: '',
  starts: false
};

const OpenWorldSceneBackgrounds = ({
  novelId, sceneId, scene, setScene, novel, loading, setLoading, error, setError, isProduction = false
}) => {
  const { showForm, editingIndex, formData, setFormData, openAdd, openEdit, close } = useListForm(INITIAL_DATA);
  const { saveScene } = useSceneUpdate(novelId, sceneId, isProduction, setScene, setLoading, 'open_world');

  const handleEditClick = (bg, index) => {
    openEdit({
      background_id: bg.background_id,
      starts: bg.starts || false
    }, index);
  };

  const handleSave = async () => {
    if (!formData.background_id) {
      setError('Выберите фон');
      return;
    }
    setError(null);
    const updated = [...(scene?.backgrounds_custom || [])];
    const item = {
      background_id: formData.background_id,
      starts: formData.starts
    };

    // If starts=true, set all others to starts=false
    if (item.starts) {
      for (let i = 0; i < updated.length; i++) {
        if (i !== editingIndex) updated[i] = { ...updated[i], starts: false };
      }
    }

    if (editingIndex !== null) {
      updated[editingIndex] = item;
    } else {
      updated.push(item);
    }
    const success = await saveScene({ ...scene, backgrounds_custom: updated }, 'Фон успешно сохранен!');
    if (success) close();
  };

  const handleDelete = async (index) => {
    if (!window.confirm('Вы уверены, что хотите удалить этот фон из сцены?')) return;
    const updated = [...(scene?.backgrounds_custom || [])];
    updated.splice(index, 1);
    await saveScene({ ...scene, backgrounds_custom: updated }, 'Фон успешно удален!');
  };

  const getBackgroundName = (id) => novel?.assets?.backgrounds?.find(a => a.id === id)?.name || 'Неизвестный фон';

  return (
    <div className="owbg-wrap">
      <div className="owbg-header">
        <h3 className="owbg-title">Фоны сцены (Открытый мир)</h3>
      </div>

      <div className="owbg-add-wrap">
        <button className="owbg-add-btn" onClick={openAdd} disabled={loading}>
          <span className="button-icon">➕</span>
          Добавить фон
        </button>
      </div>

      {error && <div className="owbg-error">{error}</div>}

      {showForm && (
        <div className="owbg-overlay">
          <div className="owbg-modal">
            <h3 className="owbg-modal-title">{editingIndex !== null ? 'Редактировать фон' : 'Добавить фон'}</h3>

            <div className="owbg-form-group">
              <label className="owbg-label">Ресурс фона:</label>
              <CustomSelect
                value={formData.background_id}
                onChange={(e) => setFormData({ ...formData, background_id: e.target.value })}
                className="app-select" disabled={loading} required
              >
                <option value="">Выберите фон</option>
                {novel?.assets?.backgrounds?.map((bg) => (
                  <option key={bg.id} value={bg.id}>{bg.name}</option>
                ))}
              </CustomSelect>
            </div>

            <div className="owbg-form-group">
              <div className="owbg-checkbox-wrap">
                <input
                  type="checkbox" className="owbg-checkbox"
                  checked={formData.starts}
                  onChange={(e) => setFormData({ ...formData, starts: e.target.checked })}
                  disabled={loading}
                />
                <label className="owbg-starts-label">Стартовый фон</label>
              </div>
              <small className="owbg-help">Только один фон может быть стартовым</small>
            </div>

            <div className="owbg-form-actions">
              <button type="button" onClick={handleSave} disabled={loading} className="owbg-btn-primary">
                {loading ? 'Загрузка...' : 'Сохранить'}
              </button>
              <button type="button" onClick={() => { close(); setError(null); }} disabled={loading} className="owbg-btn-cancel">
                Отменить
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="owbg-list">
        {scene?.backgrounds_custom?.length > 0 ? (
          scene.backgrounds_custom.map((bg, index) => (
            <div key={index} className="owbg-card">
              <div className="owbg-card-head">
                <h4 className="owbg-card-name">
                  {getBackgroundName(bg.background_id)}
                  {bg.starts && <span className="owbg-starts-badge">Стартовый</span>}
                </h4>
                <div className="owbg-card-actions">
                  <button className="owbg-btn-edit" onClick={() => handleEditClick(bg, index)} disabled={loading}>Редактировать</button>
                  <button className="owbg-btn-delete" onClick={() => handleDelete(index)} disabled={loading}>Удалить</button>
                </div>
              </div>
              <div className="owbg-card-body" />
            </div>
          ))
        ) : (
          <div className="owbg-empty">
            <p>В этой сцене пока нет фонов.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OpenWorldSceneBackgrounds;
